// extracted by mini-css-extract-plugin
module.exports =  {"root":"djBA2Wu4Z3yJDar85dld"};